import {hasQuotePermission, isQuotePermission} from '../../../../utils/quote-access';
import {Component, inject, OnInit, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Permissions} from "../../../../enums/permissions";
import {SessionService} from "../../../../services/session.service";
import {UserStorageService} from "../../../../services/user-storage.service";

@Component({
  selector: 'app-authorized-header',
  templateUrl: './authorized-header.component.html',
  styleUrl: './authorized-header.component.css',
  standalone: false
})
export class AuthorizedHeaderComponent implements OnInit {
  currentUser: any = null;
  isServiceRequestPopupVisible: boolean = false;
  isMobileMenuVisible: boolean = false;

  protected readonly Permission = Permissions;
  private readonly sessionService = inject(SessionService);
  private readonly userStorageService = inject(UserStorageService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.sessionService.currentUser
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => this.currentUser = res.user);
  }

  getPendingServiceRequestAssetsCount() {
    const storedData = this.userStorageService.getValue('serviceRequest');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      if (Array.isArray(parsedData)) {
        return parsedData.length;
      }
    }
    return 0;
  }

  isOwner(): boolean {
    return this.currentUser?.is_owner;
  }

  isOwnerOrRentee(): boolean {
    return this.currentUser?.is_owner || this.currentUser?.is_rentee;
  }

  isOnlyRentee(): boolean {
    return !this.currentUser?.is_owner && !!this.currentUser?.is_rentee;
  }

  toggleServiceRequestPopup() {
    this.isServiceRequestPopupVisible = !this.isServiceRequestPopupVisible;
  }

  closeServiceRequestPopup() {
    this.isServiceRequestPopupVisible = false;
  }

  hasPermission(permission: string): any {
    if (isQuotePermission(permission)) return hasQuotePermission(this.currentUser, permission);
    if (!this.currentUser?.permission) return false;
    const permissions = this.currentUser.permission.split(',');
    return permissions.includes(permission);
  }

  toggleMobileMenu() {
    this.isMobileMenuVisible = !this.isMobileMenuVisible;
  }
}
